export const BlankContainer = ({children})=>{
return <div className="bg-white h-fit p-3 flex-grow">
{children}
</div>
}